<template>
  <div :class="[_isMobile() ? 'mobile' : '']">
    <div v-if="_isMobile()">
      <h3>请使用电脑浏览器打开此报告，获取更佳体验</h3>
    </div>
    <div v-if="!_isMobile() && reportInfo" class="report" ref="html2canvas">
      <div class="header">
          <div class="logo">
            <img :src="logo ? logo : '/img/logo.png'" alt="" />
          </div>
          <h2 class="title">人工智能核心素养测评报告（校区版）</h2>
      </div>
      <a-divider></a-divider>
      <a-row class="info">
        <a-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24">
            <ul class="base-info-list">
              <li>
                <span class="info-title"
                  >参测单位：{{reportInfo.baseInfo.agentName}}</span
                >
              </li>
              <li>
                <span class="info-title"
                  >所属地区：{{reportInfo.baseInfo.agentAddress}}</span
                >
              </li>
              <li>
                <span class="info-title"
                  >单位类型：{{reportInfo.baseInfo.agentType}}</span
                >
              </li>
              <li>
                <span class="info-title"
                  >参测人数：{{ reportInfo.baseInfo.total }}</span
                >
              </li>
              <li>
                <span class="info-title"
                  >参测项目：{{ reportInfo.baseInfo.eventCategory }}</span
                >
              </li>
              <li v-if="reportInfo.baseInfo.paperNames">
                <span class="info-title"
                  >参测试卷：{{ reportInfo.baseInfo.paperNames }}</span
                >
              </li>
            </ul>
        </a-col>
        <a-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
          <a-card class="report-card"  :bordered="false">
            <div>
              <i class="progress-prefix"></i>
              <a-progress style="width:90%" :strokeWidth="20" :showInfo="false" :stroke-color="{'0%': 'rgb(255,255,255)','100%': 'rgb(254,178,16)'}" :percent="reportInfo.baseInfo.greatCount/reportInfo.baseInfo.total * 100"/>
            </div>
            <div style="margin:10px">
              <h3>优秀率<span style="float: right;">{{reportInfo.baseInfo.greatCount}}/{{reportInfo.baseInfo.total}}</span></h3>
            </div>
            <div>
              <i class="progress-prefix"></i>
              <a-progress style="width:90%"  :strokeWidth="20" :showInfo="false" :stroke-color="{'0%': 'rgb(255,255,255)','100%': 'rgb(131,194,112)'}" :percent="reportInfo.baseInfo.passCount/reportInfo.baseInfo.total * 100"/>
            </div>
            <div style="margin:10px">
              <h3>合格率<span style="float: right;">{{reportInfo.baseInfo.passCount}}/{{reportInfo.baseInfo.total}}</span></h3>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-card v-for="(value, key, index) in reportInfo.tag" :key="index" class="report-card" :bordered="false" style="min-height: 350px">
        <a-row type="flex" justify="space-around">
          <h2 v-if="_isMobile()" class="tag-title">{{key}}</h2>
          <a-col :flex="_isMobile()? '300px' : '500px'">
            <div
              class="chart"
              :id="'chart-tag-'+index"
              :style="_isMobile()? 'width: 300px; height: 300px':'width: 550px; height: 400px'"
            ></div>
            
          </a-col>
          <a-col v-if="!_isMobile()" flex="5px">
            <div class="divider"></div>
          </a-col>
          <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <h2 v-if="!_isMobile()" class="tag-title">{{key}}</h2>
            <a-row class="tag-item" type="flex" align="middle" :gutter="[16,16]" v-for="(item, i) in value" :key="i">
                <a-col :xl="5" :lg="5" :md="5" :sm="24" :xs="24">
                    <h3 class="tag-name">{{item.tagName}}</h3>
                </a-col>
                <a-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
                    <a-progress :strokeWidth="20" :showInfo="false" 
                    :class="item.gotScore<item.tagAvgGotScore?'top':''"
                    :stroke-color="{'0%': 'rgb(255,255,255)','100%': 'rgb(235,121,84)'}" 
                    :percent="item.gotScore/item.score * 100"/>
                </a-col>
                <a-col :xl="11" :lg="11" :md="11" :sm="24" :xs="24">
                    <div v-if="getTagDesc(item)" class="dash-border">
                        {{getTagDesc(item)}}
                    </div>
                    <h3 v-else class="tag-percent-text">
                      <span style="color:rgb(235,121,84)">{{ (item.gotScore/item.score * 100).toFixed(1)}}</span>
                      <span> / </span>
                      <span style="color:rgb(104,165,254)">{{(item.tagAvgGotScore/item.score * 100).toFixed(1)}}</span>
                   </h3>
                </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
      <a-card v-if="reportInfo.codeScoreDist" class="report-card" :bordered="false" style="min-height: 350px">
        <h2 class="tag-title">学生考评结果分析</h2>
        <!-- 实操得分分布 -->
        <a-row>
          <a-col v-for="(dist, index) in reportInfo.codeScoreDist" :key="index" :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <div
              class="chart" :id="'chart-score-dist-'+index" style="width: 100%; height: 400px"
            ></div>
          </a-col>
        </a-row>
        <!-- 知识点 -->
        <div
          class="chart" id="chart-knowledge-right-percent" style="width: 100%; height: 600px"></div>
      </a-card>
      <div class="footer">
        <h2 class="tips">本报告评价维度及标准基于《中国自动化学会青少年人工智能核心素养测评等级标准与测评大纲》中的各模块及对应级别考评要求。</h2>
        <br><br>
        <a-row type="flex" align="middle" :gutter="[16,16]">
            <a-col :span="14">
               <!-- <div class="copy">
                <h2>主&nbsp;&nbsp;办&nbsp;&nbsp;单&nbsp;&nbsp;位：中国自动化学会</h2>
                <h2>承&nbsp;&nbsp;办&nbsp;&nbsp;单&nbsp;&nbsp;位：CAA智慧教育专业委员会 CAA普及工作委会</h2>
                <h2>学术指导单位：中国科学院大学人工智能学院 西安交通大学计算机科学与技术学院 华中师范大学人工智能教育学部</h2>
               </div> -->
              <table class="copy">
                <tr>
                  <td valign="top"><h2>测&nbsp;&nbsp;评&nbsp;&nbsp;单&nbsp;&nbsp;位：&nbsp;&nbsp;</h2></td>
                  <td><h2>AICE青少年人工智能核心素养测评工作组</h2></td>
                </tr>
                <tr>
                  <td valign="top"><h2>学术指导单位：</h2></td>
                  <td><h2>中国科学院大学人工智能学院<br>西安交通大学计算机科学与技术学院<br>华中师范大学人工智能教育学部</h2></td>
                </tr>
               </table>
            </a-col>
            <a-col flex="200px">
                <img
                    class="logo"
                    src="/cert/qrcode.jpg"
                />
            </a-col>
            <a-col :span="6">
                <div class="concat">
                    <h2>电话：4006-982-989</h2>
                    <h2>官网：aice.caa.org.cn</h2>
                </div>
            </a-col>
        </a-row>
      </div>
    </div>
    <a-button v-if="reportInfo" style="margin:10px auto;display:block;" icon="download" size="large" type="primary" @click="downloadReport">下载报告</a-button>
    <!-- <img :src="img" alt=""> -->
  </div>
</template>

<script>
import {mixinDevice} from '@/utils/mixin.js'
import { getAction } from "@/api/manage";
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import * as echarts from "echarts";
export default {
  mixins: [mixinDevice],
  components: {
  },
  data() {
    return {
      id: "",
      agentId: "",
      eventCategory: "",
      eventId: "",
      paperId: "",
      logo: "",
      reportInfo: null,
      //平均情况雷达图style
      areaStyle1: {
        color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
          {
            color: "rgba(104,165,254, 0.1)",
            offset: 0,
          },
          {
            color: "rgba(104,165,254, 0.5)",
            offset: 1,
          },
        ]),
      },
      //本校情况雷达图style
      areaStyle2: {
        color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
          {
            color: "rgba(235,121,84, 0.1)",
            offset: 0,
          },
          {
            color: "rgba(235,121,84, 0.5)",
            offset: 1,
          },
        ]),
      },
    };
  },
  created() {
    if(this._isMobile()){
      //alert("请使用电脑浏览器打开此报告，获取更佳体验")
      return
    }
    let tenantInfo = this.$store.getters.tenantInfo;
    this.logo = tenantInfo.logo;
    this.id = this.$route.query.id
    this.agentId = this.$route.query.agentId;
    this.eventCategory = this.$route.query.eventCategory;
    this.paperId = this.$route.query.paperId;
    if (this.id) {
      this.getReport(this.id, null, null, null);
    }else if(!this.agentId || !this.eventCategory || !this.paperId){
      this.getReport(null, this.agentId, this.eventCategory, this.paperId);
    }else{
      this.$message.error("参数错误");
      return;
    }
  },
  mounted() {
  },
  methods: {
    getReport(id, agentId, eventCategory, paperId) {
      getAction("/report/schoolCategoryReport", {
        id: id,
        agentId: agentId,
        eventCategory: eventCategory,
        paperId: paperId
      }).then((res) => {
        if (res.success) {
          if(typeof res.result == 'string'){
            this.reportInfo = JSON.parse(res.result);
          }else{
            this.reportInfo = res.result;
          }
          this.$nextTick(() => {
            if (this.reportInfo.tag) {
              this.renderChartTags(this.reportInfo.tag)
            }
            if(this.reportInfo.codeScoreDist){
              this.renderChartScoreDist(this.reportInfo.codeScoreDist)
            }
            if(this.reportInfo.knowledgeRightPercent){
              this.renderChartKnowledgeRightPercent(this.reportInfo.knowledgeRightPercent)
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    renderChartKnowledgeRightPercent(dataSet){
      let mychart = echarts.init(document.getElementById("chart-knowledge-right-percent"));
      let xData = dataSet.map(item=>item.name)
      let yData = dataSet.map(item=>{
        item.rightPercent = item.rightPercent.toFixed(1)
        item.rightPercent = {
            value: item.rightPercent,
            itemStyle: {
              color: ''
            }
        }
        if(item.rightPercent.value > 60){
           item.rightPercent.itemStyle.color = 'rgb(117,170,66)'
        }else if(item.rightPercent.value > 40){
          item.rightPercent.itemStyle.color = 'rgb(253,229,9)'
        }else{
          item.rightPercent.itemStyle.color = 'rgb(233,71,26)'
        }
        return item.rightPercent
      })
      console.log(yData);
      mychart.showLoading();
        let option = {
            title: {
              text: '综合正确率',
              left: 'center'
            },
            xAxis: {
              type: 'category',
              data: xData,
              axisLabel: { interval: 0, rotate: 30,
                textStyle: {
                  fontSize: 10, 
                  height: 100 // 设置标签的行高
                }
              }
            },
            yAxis: {
              type: 'value'
            },
            series: [
            {
              data: yData,
              type: 'bar',
              barMaxWidth: 30, // 设置数据柱的最大宽度
              itemStyle: {
                borderRadius: [50, 50, 0, 0] // 设置柱形的上方为圆角
              },
              label: {
                show: true,
                position: 'top',
                formatter: '{c}' // 显示数据值
              }
            }
          ]
        }
        setTimeout(function () {
          mychart.setOption(option);
          mychart.hideLoading();
        }, 100);
    },
    renderChartScoreDist(dataSet){
      console.log(dataSet);
      let that = this;
      for(let index in dataSet){
        let data = dataSet[index]
        console.log(data);
        let xData = data.questionDist.map(item=>item.score)
        let yData = data.questionDist.map(item=>item.count)
        console.log(xData,yData);
        let mychart = echarts.init(document.getElementById("chart-score-dist-"+index));
        mychart.showLoading();
        let option = {
            title: {
              text: '实操'+(parseInt(index)+1)+'分数分布（满分'+data.questionScore+'）',
              left: 'center'
            },
            xAxis: {
              type: 'category',
              data: xData,
            },
            yAxis: {
              type: 'value'
            },
            series: [
            {
              data: yData,
              type: 'bar',
              barMaxWidth: 30, // 设置数据柱的最大宽度
              itemStyle: {
                borderRadius: [50, 50, 0, 0] // 设置柱形的上方为圆角
              },
              label: {
                show: true,
                position: 'top',
                formatter: '{c}' // 显示数据值
              }
            }
          ]
        }
        setTimeout(function () {
          mychart.setOption(option);
          mychart.hideLoading();
        }, 100);
      }
    },
    renderChartTags(dataSet){
      let index = 0
       for(let key in dataSet){
        let data = dataSet[key]
        console.log(data);
        let mychart = echarts.init(document.getElementById("chart-tag-"+index));
        mychart.showLoading();
        let option = {
          color:['rgb(104,165,254)','rgb(235,121,84)'],
          legend: {
            data: ["平均情况", "本校情况"],
            left: '0%'
          },
          radar: {
            indicator: [],
            radius: this._isMobile()?'40%':'75%'
          },
          series: [
            {
              name: key,
              type: "radar",
              data: [
                {
                  value: [],
                  name: "平均情况",
                  areaStyle: this.areaStyle1
                },
                {
                  value: [],
                  name: "本校情况",
                  areaStyle: this.areaStyle2
                },
              ],
            },
          ],
        };
        for (let i = 0; i < data.length; i++) {
          let t = data[i];
          option.radar.indicator.push({ name: t.tagName, max: 1 });
          option.series[0].data[0].value.push(t.tagAvgGotScore / t.tagAvgTotalScore);
          option.series[0].data[1].value.push(t.gotScore / t.score);
        }
        setTimeout(function () {
          mychart.setOption(option);
          mychart.hideLoading();
        }, 100);
        index++
       }
    },
    getTagDesc(tag){
      if(tag.tagDesc){
        let tagDescJson
        try{
          tagDescJson = JSON.parse(tag.tagDesc)
        }catch(e){
          return tag.tagDesc
        }
        for(let i=tagDescJson.length-1;i>=0;i--){
          if((tag.gotScore/tag.score*100) >= parseInt(tagDescJson[i].key)){
            return tagDescJson[i].value
          }
        }
      }
    },
    downloadReport(){
      // 移除 box-shadow 效果
      var elements = document.querySelectorAll('.report-card,.ant-progress-bg,.ant-progress-inner');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.boxShadow = 'none';
      }
      let that = this
      html2canvas(this.$refs.html2canvas, {
        backgroundColor: null,
        useCORS: true // 解决文件跨域问题
      }).then(canvas => {
        const url = canvas.toDataURL('image/png') // 生成的图片
        saveAs(url, that.reportInfo.baseInfo.agentName+"的测评报告.png")
      })   
    },
  },
};
</script>

<style scoped lang="less">
.mobile{
  .report{
    padding: 5px;
  }
  .header{
    .logo {
      position: unset;
    }
  }
  .report-card {
    margin: 10px 5px;
    .tag-name{
      text-align: left;
    }
  }
}
.report {
  background: #f6f7fb;
  max-width: 1366px;
  margin: 0 auto;
  padding: 20px;
  font-family: "微软雅黑";
}

.header {
  min-height: 55px;
  .logo {
    position: absolute;
    margin-top: 5px;
    img {
      display: inline-block;
      height: 50px;
    }
    h2 {
      display: inline;
      font-style: italic;
      font-size: 20px;
      color: #ffffff;
      line-height: 30px;
      text-shadow: #b3b0b0ab 5px 3px 5px;
    }
  }
  .title {
    text-align: center;
    font-weight: 700;
    line-height: 55px;
  }
}

.info {
  margin: 20px;
  .info-title{
    font-weight: 700;
  }
  .photo {
    width: 180px;
    border: 3px solid rgb(210, 221, 241);
  }
  .base-info-list {
    padding: 0;
    li {
      list-style-type: none;
      background: url(../assets/report/li.png) no-repeat 0px center;
      background-size: 10px 10px;
      padding-left: 25px;
      margin: 10px 0;
      span {
        color: black;
        font-size: 16px;
      }
    }
  }
}

.report-card {
  margin: 30px 20px;
  border-radius: 20px;
  box-shadow: #d9d9d9 0px 0px 6px 0px;
  .tag-title{
    font-weight: 700;
    text-align: center;
  }
  .tag-item{
    min-height: 70px;
  }
  .tag-name{
    text-align: right;
    white-space: nowrap;
  }
  .tag-percent-text{
     text-align: left;
    margin-top: 10px;
  }
}

.chart {
  margin: auto;
}
.divider{
    height: 100%;
    width: 5px;
    background-image: linear-gradient(white, rgb(237 237 237), white);
}
.dash-border{
    border-radius:5px;
    border:1px dashed skyblue;
    padding:2px;
}
/deep/.ant-progress{
  .ant-progress-bg, .ant-progress-inner, .ant-progress-success-bg{
      box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2)!important;
  }
  .ant-progress-success-bg{
    background: linear-gradient(to right, rgb(255, 255, 255) 0%, rgb(104,165,254) 100%);
  }
}
/deep/.top{
  .ant-progress-bg{
    z-index: 99;
  }
}
.progress-prefix{
    display: inline-block;
    background: rgb(254, 178, 16);
    width: 5px;
    height: 20px;
    margin: 0px 10px;
    float: left;
}
.footer{
    .tips{
        text-align:center;
        color:gray;
    }
    .copy{
        h2{
            color: rgb(0,108,187)
        }
    }
    .logo{
        width: 200px; height: 200px; display: block; margin: 0 auto
    }
    .concat{
        h2{
            color: rgb(76,76,76);
            font-weight: 700;
        }
    }
}
</style>